module.exports = __webpack_public_path__ + "static/media/TresDeseos1.0e6777dd.jpeg";